import request from '@/utils/request'

export function getUserInfo() {
  return request({
    url: '/open/user',
    method: 'get'
  })
}

export function getThorInfo() {
  return request({
    url: '/open/thor',
    method: 'get'
  })
}

export function resetThorInfo() {
  return request({
    url: '/open/thor',
    method: 'post'
  })
}
